export function capitalize(inStr: string | undefined) {
  if (inStr === undefined) return '';
  if (!inStr) return inStr;

  return inStr.charAt(0).toUpperCase() + inStr.slice(1);
}
